import { API } from ".";

export const GET_UNIT_STORM_OPERATION_REQUEST =
  "@@operation/GET_UNIT_STORM_OPERATION_REQUEST";
export const GET_UNIT_STORM_OPERATION_SUCCESS =
  "@@operation/GET_UNIT_STORM_OPERATION_SUCCESS";
export const GET_UNIT_STORM_OPERATION_FAILURE =
  "@@operation/GET_UNIT_STORM_OPERATION_FAILURE";

export function getunitStormOperation(id, operationId) {
  if (!id) return;
  return async (dispatch) => {
    dispatch({
      type: GET_UNIT_STORM_OPERATION_REQUEST,
    });
    try {
      const response = await API.get(
        "cmsAPI",
        `/unit/${id}/operation/${operationId}`
      );
      dispatch({
        type: GET_UNIT_STORM_OPERATION_SUCCESS,
        payload: response,
      });
      dispatch(setUnitStormOperationLoadState(""));
    } catch (error) {
      dispatch({
        type: GET_UNIT_STORM_OPERATION_FAILURE,
        payload: error,
      });
    }
  };
}

export const CREATE_UNIT_STORM_OPERATION_REQUEST =
  "@@operation/CREATE_UNIT_STORM_OPERATION_REQUEST";
export const CREATE_UNIT_STORM_OPERATION_SUCCESS =
  "@@operation/CREATE_UNIT_STORM_OPERATION_SUCCESS";
export const CREATE_UNIT_STORM_OPERATION_FAILURE =
  "@@operation/CREATE_UNIT_STORM_OPERATION_FAILURE";

export function createunitStormOperation(id, data, callback) {
  if (!id) return;
  return async (dispatch) => {
    dispatch({
      type: CREATE_UNIT_STORM_OPERATION_REQUEST,
    });
    try {
      const init = {
        body: data,
      };
      const response = await API.post("cmsAPI", `/unit/${id}/operation`, init);

      dispatch({
        type: CREATE_UNIT_STORM_OPERATION_SUCCESS,
        payload: response,
      });

      dispatch(setUnitStormOperationLoadState("starting"));

      if (callback) {
        callback();
      }
    } catch (error) {
      dispatch({
        type: CREATE_UNIT_STORM_OPERATION_FAILURE,
        payload: error,
      });
    }
  };
}

export const DELETE_UNIT_STORM_OPERATION_REQUEST =
  "@@operation/DELETE_UNIT_STORM_OPERATION_REQUEST";
export const DELETE_UNIT_STORM_OPERATION_SUCCESS =
  "@@operation/DELETE_UNIT_STORM_OPERATION_SUCCESS";
export const DELETE_UNIT_STORM_OPERATION_FAILURE =
  "@@operation/DELETE_UNIT_STORM_OPERATION_FAILURE";

export function deleteunitStormOperation(id, operationId, callback) {
  if (!id) return;
  return async (dispatch) => {
    dispatch({
      type: DELETE_UNIT_STORM_OPERATION_REQUEST,
    });
    try {
      const response = await API.del(
        "cmsAPI",
        `/unit/${id}/operation/${operationId}`
      );
      dispatch({
        type: DELETE_UNIT_STORM_OPERATION_SUCCESS,
        payload: response,
      });

      dispatch(setUnitStormOperationLoadState("stopping"));

      if (callback) {
        callback();
      }
    } catch (error) {
      dispatch({
        type: DELETE_UNIT_STORM_OPERATION_FAILURE,
        payload: error,
      });
    }
  };
}

export const CLEAR_UNIT_STORM_OPERATION =
  "@@operation/CLEAR_UNIT_STORM_OPERATION";

export function clearunitStormOperation() {
  return async (dispatch) => {
    dispatch({
      type: CLEAR_UNIT_STORM_OPERATION,
    });
  };
}

//EVBOOST

export const GET_UNIT_EVBOOST_OPERATION_REQUEST =
  "@@operation/GET_UNIT_EVBOOST_OPERATION_REQUEST";
export const GET_UNIT_EVBOOST_OPERATION_SUCCESS =
  "@@operation/GET_UNIT_EVBOOST_OPERATION_SUCCESS";
export const GET_UNIT_EVBOOST_OPERATION_FAILURE =
  "@@operation/GET_UNIT_EVBOOST_OPERATION_FAILURE";

export function getunitEvBoostOperation(id, operationId) {
  if (!id) return;
  return async (dispatch) => {
    dispatch({
      type: GET_UNIT_EVBOOST_OPERATION_REQUEST,
    });
    try {
      const response = await API.get(
        "cmsAPI",
        `/unit/${id}/operation/${operationId}`
      );
      dispatch({
        type: GET_UNIT_EVBOOST_OPERATION_SUCCESS,
        payload: response,
      });
      dispatch(setUnitEvboostOperationLoadState(""));
    } catch (error) {
      dispatch({
        type: GET_UNIT_EVBOOST_OPERATION_FAILURE,
        payload: error,
      });
    }
  };
}

export const CREATE_UNIT_EVBOOST_OPERATION_REQUEST =
  "@@operation/CREATE_UNIT_EVBOOST_OPERATION_REQUEST";
export const CREATE_UNIT_EVBOOST_OPERATION_SUCCESS =
  "@@operation/CREATE_UNIT_EVBOOST_OPERATION_SUCCESS";
export const CREATE_UNIT_EVBOOST_OPERATION_FAILURE =
  "@@operation/CREATE_UNIT_EVBOOST_OPERATION_FAILURE";

export function createunitEvBoostOperation(id, data, callback) {
  if (!id) return;
  return async (dispatch) => {
    dispatch({
      type: CREATE_UNIT_EVBOOST_OPERATION_REQUEST,
    });
    try {
      const init = {
        body: data,
      };
      const response = await API.post("cmsAPI", `/unit/${id}/operation`, init);

      dispatch({
        type: CREATE_UNIT_EVBOOST_OPERATION_SUCCESS,
        payload: response,
      });

      if (data.ev1_charger === "boost") {
        dispatch(setUnitEvboostOperationLoadState("starting"));
      }

      if (callback) {
        callback();
      }
    } catch (error) {
      dispatch({
        type: CREATE_UNIT_EVBOOST_OPERATION_FAILURE,
        payload: error,
      });
    }
  };
}

export const DELETE_UNIT_EVBOOST_OPERATION_REQUEST =
  "@@operation/DELETE_UNIT_EVBOOST_OPERATION_REQUEST";
export const DELETE_UNIT_EVBOOST_OPERATION_SUCCESS =
  "@@operation/DELETE_UNIT_EVBOOST_OPERATION_SUCCESS";
export const DELETE_UNIT_EVBOOST_OPERATION_FAILURE =
  "@@operation/DELETE_UNIT_EVBOOST_OPERATION_FAILURE";

export function deleteunitEvBoostOperation(id, operationId, callback) {
  if (!id) return;
  return async (dispatch) => {
    dispatch({
      type: DELETE_UNIT_EVBOOST_OPERATION_REQUEST,
    });
    try {
      const response = await API.del(
        "cmsAPI",
        `/unit/${id}/operation/${operationId}`
      );
      dispatch({
        type: DELETE_UNIT_EVBOOST_OPERATION_SUCCESS,
        payload: response,
      });

      dispatch(setUnitEvboostOperationLoadState("stopping"));

      if (callback) {
        callback();
      }
    } catch (error) {
      dispatch({
        type: DELETE_UNIT_EVBOOST_OPERATION_FAILURE,
        payload: error,
      });
    }
  };
}

export const CLEAR_UNIT_EVBOOST_OPERATION =
  "@@operation/CLEAR_UNIT_EVBOOST_OPERATION";

export function clearunitEvBoostOperation() {
  return async (dispatch) => {
    dispatch({
      type: CLEAR_UNIT_EVBOOST_OPERATION,
    });
  };
}

export const SET_UNIT_STORM_OPERATION_LOAD_STATE =
  "@@operation/SET_UNIT_STORM_OPERATION_LOAD_STATE";

export function setUnitStormOperationLoadState(value) {
  return async (dispatch) => {
    dispatch({
      type: SET_UNIT_STORM_OPERATION_LOAD_STATE,
      payload: value,
    });
  };
}

export const SET_UNIT_EVBOOST_OPERATION_LOAD_STATE =
  "@@operation/SET_UNIT_EVBOOST_OPERATION_LOAD_STATE";

export function setUnitEvboostOperationLoadState(value) {
  return async (dispatch) => {
    dispatch({
      type: SET_UNIT_EVBOOST_OPERATION_LOAD_STATE,
      payload: value,
    });
  };
}

export const GET_SETTINGS_STORM_OPERATION_REQUEST =
  "@@operation/GET_SETTINGS_STORM_OPERATION_REQUEST";
export const GET_SETTINGS_STORM_OPERATION_SUCCESS =
  "@@operation/GET_SETTINGS_STORM_OPERATION_SUCCESS";
export const GET_SETTINGS_STORM_OPERATION_FAILURE =
  "@@operation/GET_SETTINGS_STORM_OPERATION_FAILURE";

export function getSettingsStormOperation(id) {
  if (!id) return;
  return async (dispatch) => {
    dispatch({
      type: GET_SETTINGS_STORM_OPERATION_REQUEST,
    });
    try {
      const response = await API.get("cmsAPI", `/unit/${id}/operation`);
      dispatch({
        type: GET_SETTINGS_STORM_OPERATION_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_SETTINGS_STORM_OPERATION_FAILURE,
        payload: error,
      });
    }
  };
}

export const GET_SETTINGS_EVBOOST_OPERATION_REQUEST =
  "@@operation/GET_SETTINGS_EVBOOST_OPERATION_REQUEST";
export const GET_SETTINGS_EVBOOST_OPERATION_SUCCESS =
  "@@operation/GET_SETTINGS_EVBOOST_OPERATION_SUCCESS";
export const GET_SETTINGS_EVBOOST_OPERATION_FAILURE =
  "@@operation/GET_SETTINGS_EVBOOST_OPERATION_FAILURE";

export function getSettingsEvBoostOperation(id) {
  if (!id) return;
  return async (dispatch) => {
    dispatch({
      type: GET_SETTINGS_EVBOOST_OPERATION_REQUEST,
    });
    try {
      const response = await API.get("cmsAPI", `/unit/${id}/operation`);
      dispatch({
        type: GET_SETTINGS_EVBOOST_OPERATION_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_SETTINGS_EVBOOST_OPERATION_FAILURE,
        payload: error,
      });
    }
  };
}

// Hot water

export const GET_HOTWATER_OPERATION_REQUEST =
  "@@operation/GET_HOTWATER_OPERATION_REQUEST";
export const GET_HOTWATER_OPERATION_SUCCESS =
  "@@operation/GET_HOTWATER_OPERATION_SUCCESS";
export const GET_HOTWATER_OPERATION_FAILURE =
  "@@operation/GET_HOTWATER_OPERATION_FAILURE";

export function getHotwaterOperation(id, operationId) {
  if (!id) return;
  return async (dispatch) => {
    dispatch({
      type: GET_HOTWATER_OPERATION_REQUEST,
    });
    try {
      const response = await API.get(
        "cmsAPI",
        `/unit/${id}/operation/${operationId}`
      );
      dispatch({
        type: GET_HOTWATER_OPERATION_SUCCESS,
        payload: response,
      });
      dispatch(setHotwaterOperationLoadState(""));
    } catch (error) {
      dispatch({
        type: GET_HOTWATER_OPERATION_FAILURE,
        payload: error,
      });
    }
  };
}

export const CREATE_HOTWATER_OPERATION_REQUEST =
  "@@operation/CREATE_HOTWATER_OPERATION_REQUEST";
export const CREATE_HOTWATER_OPERATION_SUCCESS =
  "@@operation/CREATE_HOTWATER_OPERATION_SUCCESS";
export const CREATE_HOTWATER_OPERATION_FAILURE =
  "@@operation/CREATE_HOTWATER_OPERATION_FAILURE";

export function createHotwaterOperation(id, data, callback) {
  if (!id) return;
  return async (dispatch) => {
    dispatch({
      type: CREATE_HOTWATER_OPERATION_REQUEST,
    });
    try {
      const init = {
        body: data,
      };
      const response = await API.post("cmsAPI", `/unit/${id}/operation`, init);

      dispatch({
        type: CREATE_HOTWATER_OPERATION_SUCCESS,
        payload: response,
      });

      dispatch(setHotwaterOperationLoadState("starting"));

      if (callback) {
        callback();
      }
    } catch (error) {
      dispatch({
        type: CREATE_HOTWATER_OPERATION_FAILURE,
        payload: error,
      });
    }
  };
}

export const DELETE_HOTWATER_OPERATION_REQUEST =
  "@@operation/DELETE_HOTWATER_OPERATION_REQUEST";
export const DELETE_HOTWATER_OPERATION_SUCCESS =
  "@@operation/DELETE_HOTWATER_OPERATION_SUCCESS";
export const DELETE_HOTWATER_OPERATION_FAILURE =
  "@@operation/DELETE_HOTWATER_OPERATION_FAILURE";

export function deleteHotwaterOperation(id, operationId, callback) {
  if (!id) return;
  return async (dispatch) => {
    dispatch({
      type: DELETE_HOTWATER_OPERATION_REQUEST,
    });
    try {
      const response = await API.del(
        "cmsAPI",
        `/unit/${id}/operation/${operationId}`
      );
      dispatch({
        type: DELETE_HOTWATER_OPERATION_SUCCESS,
        payload: response,
      });

      dispatch(setHotwaterOperationLoadState("stopping"));

      if (callback) {
        callback();
      }
    } catch (error) {
      dispatch({
        type: DELETE_HOTWATER_OPERATION_FAILURE,
        payload: error,
      });
    }
  };
}

export const CLEAR_HOTWATER_OPERATION = "@@operation/CLEAR_HOTWATER_OPERATION";

export function clearHotwaterOperation() {
  return async (dispatch) => {
    dispatch({
      type: CLEAR_HOTWATER_OPERATION,
    });
  };
}

export const SET_HOTWATER_OPERATION_LOAD_STATE =
  "@@operation/SET_HOTWATER_OPERATION_LOAD_STATE";

export function setHotwaterOperationLoadState(value) {
  return async (dispatch) => {
    dispatch({
      type: SET_HOTWATER_OPERATION_LOAD_STATE,
      payload: value,
    });
  };
}
